export function getAttendanceIndexRoute (state, getters) {
  if (state.permissions.includes('edit_punches') || state.permissions.includes('view_reports')) {
    return 'timecard-editor'
  }
  if (getters.canAccessManagePunches) return 'punch-list'
  if (state.features.includes('geo') && getters.geoEnabled && state.permissions.includes('manage_clock_logs')) {
    return 'geomap'
  }
  if (state.permissions.includes('manage_clock_logs')) return 'clock-log-list'
  if (state.features.includes('discipline') && getters.disciplineEnabled && state.permissions.includes('manage_discipline')) {
    return 'discipline-infractions'
  }
  return 'clock-log-list'
}